import { Controller, FieldValues } from 'react-hook-form';
import AutoComplete from '../FormInputs/autocompletes/Autocomplete/AutoComplete';
import { RHFAutocompleteProps } from './types/reactHookFormAutocomplete.types';

const RHFAutocomplete = <TOption, TForm extends FieldValues>({
  name,
  control,
  onBlur,
  ...autocompleteProps
}: RHFAutocompleteProps<TOption, TForm>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <AutoComplete<TOption>
          {...autocompleteProps}
          value={field.value}
          onChange={(_, value) => field.onChange(value)}
          onBlur={(event) => {
            field.onBlur();
            onBlur?.(event);
          }}
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
        />
      )}
    />
  );
};

export default RHFAutocomplete;
